export const STANDALONE_DISPLAY_QUERY = '(display-mode: standalone)';

export type DisplayMode = 'app' | 'browser';

export function isStandaloneDisplay(media = window.matchMedia): boolean {
  try {
    if (media?.(STANDALONE_DISPLAY_QUERY)?.matches) return true;
  } catch {
    // matchMedia can throw in older or restricted environments.
  }
  return (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
}

/** `app` when Crimson runs as an installed app window, `browser` in a normal tab. */
export function getDisplayMode(media = window.matchMedia): DisplayMode {
  return isStandaloneDisplay(media) ? 'app' : 'browser';
}
